module.exports = __webpack_public_path__ + "h5/img/avator.d2e5b262.jpg";